// @flow
import * as React from 'react'

import classnames from 'classnames'
import { Label, Flex } from 'components/common'
import { withoutPropagation } from '~/core/utils/functions'
import { useListStyles, useListItemStyles } from './styles'

type ListProps = {
  children: React.Node,
  label?: string,
  isDisabled?: boolean,
  wrapperProps?: {
    [key: string]: any
  }
}
const List = ({ children, label, isDisabled, wrapperProps = {} }: ListProps) => {
  const classes = useListStyles()
  return (
    <Flex column {...wrapperProps}>
      {label && <Label>{label}</Label>}
      <ul
        className={classnames(classes.list, 'list', {
          disabled: isDisabled
        })}
      >
        {children}
      </ul>
    </Flex>
  )
}

type ListItemProps = {
  id?: string,
  children?: React.Node,
  content?: Array<{
    label: string,
    value: string,
    color?: string
  }>,
  isEditable?: boolean,
  isRemovable?: boolean,
  isAddable?: boolean,
  onEdit?: (event: SyntheticEvent<HTMLElement>) => void,
  onRemove?: (event: SyntheticEvent<HTMLElement>) => void,
  onAdd?: (event: SyntheticEvent<HTMLElement>) => void
}

List.Item = ({
  id,
  children,
  content = [],
  isRemovable,
  isEditable,
  isAddable,
  onEdit = () => {},
  onRemove = () => {},
  onAdd = () => {},
  ...props
}: ListItemProps) => {
  const classes = useListItemStyles() // eslint-disable-line
  return (
    <li className={classes.listItem} id={id} {...props}>
      {children ? (
        <div className={classes.listItemContent}>{children}</div>
      ) : (
        <div className={classes.listItemContent}>
          {content.map(({ label, value, color }, index) => (
            <p key={`${label}-${value}-${index}`}>
              <strong style={{ marginRight: '0.5rem' }}>{label}:</strong>
              <span style={{ color: color || 'inherit' }} title={value}>{` ${value}`}</span>
            </p>
          ))}
        </div>
      )}
      <div className={classnames(classes.listItemActions, 'list-item-actions')}>
        {isAddable && (
          <a
            className="btn btn-flat list_item_action-close"
            style={{
              width: 40
            }}
            onClick={withoutPropagation(onAdd)}
          >
            <i className="icon icon-m">add</i>
          </a>
        )}
        {isEditable && (
          <a
            className="btn btn-flat list_item_action-close"
            style={{
              width: 40
            }}
            onClick={withoutPropagation(onEdit)}
          >
            <i className="icon icon-m">edit</i>
          </a>
        )}
        {isRemovable && (
          <a
            className="btn btn-flat list_item_action-close"
            style={{
              width: 40
            }}
            onClick={withoutPropagation(onRemove)}
          >
            <i className="icon icon-m">close</i>
          </a>
        )}
      </div>
    </li>
  )
}

export { List }
